<lib-card>
  <ng-container title>Documentazione Amministrativa</ng-container>
  <ng-container content>
    @if (administrativeOffer(); as offer) {
      <div class="flex flex-col gap-5 pt-4">
        <div class="flex items-center gap-3">
          <span
            class="text-sm font-semibold uppercase tracking-wide text-slate-500"
            >Esito preliminare:</span
          >
          <span
            class="rounded-full px-3 py-1 text-sm font-bold uppercase tracking-wide"
            [class]="outcomeClasses()"
          >
            {{ offer.preliminaryOutcome }}
          </span>
        </div>

        @if (offer.generalEvaluatorNotes) {
          <p class="text-base leading-relaxed text-slate-600">
            {{ offer.generalEvaluatorNotes }}
          </p>
        }

        @if (documents().length) {
          <div class="flex flex-col gap-3">
            <span
              class="text-sm font-semibold uppercase tracking-wide text-slate-500"
              >Documenti richiesti</span
            >
            <div
              class="flex flex-col divide-y divide-slate-100 overflow-hidden rounded-xl border border-slate-200 bg-white"
            >
              @for (item of documents(); track $index) {
                @let doc = item.doc;
                <div class="flex flex-col gap-1 px-4 py-3">
                  <div class="flex items-start justify-between gap-3">
                    <span
                      class="text-md font-medium leading-snug text-slate-800"
                      >{{ doc.requiredDocumentName }}</span
                    >
                    <span
                      class="shrink-0 rounded-full px-2.5 py-0.5 text-sm font-bold uppercase"
                      [class]="item.badge.classes"
                    >
                      {{ item.badge.label }}
                    </span>
                  </div>
                  @if (doc.notes) {
                    <p class="m-0 text-sm leading-snug text-slate-500">
                      {{ doc.notes }}
                    </p>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </ng-container>
</lib-card>
